'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProductMetafields = exports.fetchProductData = exports.fetchJSON = exports.getDefaultRequestConfig = exports.isBetween = exports.resizeImage = exports.formatMoney = exports.range = exports.heightWithoutPadding = exports.styleToNumber = exports.serializeQueryParams = exports.createElement = exports.doesStringContainAny = exports.getElements = exports.getElement = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.getOffsetTop = getOffsetTop;
exports.setCountryCode = setCountryCode;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};
var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? Array.from(items) : items;
};

var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);
  Object.entries(options).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    el.setAttribute(key, value);
  });

  return el;
};

var serializeQueryParams = exports.serializeQueryParams = function serializeQueryParams(params) {
  return Object.entries(params).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

var styleToNumber = exports.styleToNumber = function styleToNumber(str) {
  return parseInt(str, 10);
};

var heightWithoutPadding = exports.heightWithoutPadding = function heightWithoutPadding(node) {
  var _window$getComputedSt = window.getComputedStyle(node),
      paddingTop = _window$getComputedSt.paddingTop,
      paddingBottom = _window$getComputedSt.paddingBottom;

  return styleToNumber(paddingTop) + styleToNumber(paddingBottom);
};

var range = exports.range = function range(amount) {
  return [].concat((0, _toConsumableArray3.default)(Array(amount).keys()));
};

var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme.moneyFormat;

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var resizeImage = exports.resizeImage = function resizeImage() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      src = _ref5.src,
      size = _ref5.size,
      _ref5$crop = _ref5.crop,
      crop = _ref5$crop === undefined ? null : _ref5$crop,
      _ref5$scale = _ref5.scale,
      scale = _ref5$scale === undefined ? null : _ref5$scale;

  if (size == null) {
    return src;
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '');
  }

  var match = src.match(/\.(jpg|jpeg|pjpg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];
    var scaleString = scale ? '@' + scale + 'x' : '';
    var cropString = crop ? '_crop_' + crop : '';

    return (prefix[0] + '_' + size + cropString + scaleString + suffix).replace(/http(s)?:/, '');
  } else {
    return null;
  }
};

var isBetween = exports.isBetween = function isBetween() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      number = _ref6.number,
      startNumber = _ref6.startNumber,
      endNumber = _ref6.endNumber,
      _ref6$includeSupplied = _ref6.includeSupplied,
      includeSupplied = _ref6$includeSupplied === undefined ? true : _ref6$includeSupplied;

  return includeSupplied ? startNumber <= number && number <= endNumber : startNumber < number && number < endNumber;
};

/**
 * This is the default config we will use when using fetch()
 *
 * @returns {Object}
 */
var getDefaultRequestConfig = exports.getDefaultRequestConfig = function getDefaultRequestConfig() {
  return JSON.parse(JSON.stringify({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
};

/**
 * Default fetch boilerplate
 * @param {String} url - The URL we are looking to fetch
 * @param {Object} [config] - .fetch config to override the default
 *
 * @returns {Promise}
 */
var fetchJSON = exports.fetchJSON = function fetchJSON(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // eslint-disable-next-line compat/compat
  return fetch(url, Object.assign({}, getDefaultRequestConfig(), config)).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

/**
 * This will fetch product data from Shopify's AJAX API by handle
 *
 * @param {String} handle - The products handle
 *
 * @returns {Promise}
 */
var fetchProductData = exports.fetchProductData = function fetchProductData(handle) {
  try {
    return fetchJSON('/products/' + handle + '.js');
  } catch (e) {
    console.error(e);
  }
};

var fetchProductMetafields = exports.fetchProductMetafields = function fetchProductMetafields(handle) {
  try {
    return fetchJSON('/products/' + handle + '?view=json', {
      method: 'GET'
    });
  } catch (e) {
    console.error(e);
  }
};

/**
 * Gets the offsetTop of the passed element relevant to it's offsetParent
 *
 * @param {HTMLElement|Element} el - The element we'll be getting the offsetTop for
 * @param {Document|HTMLElement} [parent=HTMLBodyElement] - The offsetParent we want to get the offsetTop relative to
 * @param {Number} [offsetTop=0] - The starting offsetTop. This tends to be 0 but given this is a
 *   recursive function, we need to pass it to let it build up
 *
 * @returns {Number}
 */
function getOffsetTop(el) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var offsetTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!isNaN(el.offsetTop)) {
    offsetTop += el.offsetTop;
  }

  return el.offsetParent === parent ? offsetTop : getOffsetTop(el.offsetParent, parent, offsetTop);
}

function setCountryCode() {
  var countryCodeIsSet = _jsCookie2.default.get('countryCode');

  if (!countryCodeIsSet) {
    fetchJSON('/browsing_context_suggestions.json').then(function (response) {
      var event = new CustomEvent('COUNTRY_CODE_SET', {
        detail: {
          country_code: response.detected_values.country.handle
        },
        bubbles: true
      });

      _jsCookie2.default.set('countryCode', event.detail.country_code, { expires: 3650 });

      document.body.dispatchEvent(event);
    });
  }
}